import { Theme } from '@mui/material'

const useStyles = {
  addBackupNumberButton: {
    textTransform: 'none',
    marginTop: 1,
    alignSelf: 'flex-start',
  },
  selectTypeText: {
    fontWeight: '500',
  },
  roleTypeContainer: {
    marginTop: 1.5,
    alignItems: 'center',
  },
  callCenterDefinitionContainer: (theme: Theme) => ({
    borderRadius: 1,
    backgroundColor: theme.palette.ui.surfaceContainer,
    paddingY: 1.5,
    paddingX: 2,
    gap: 2,
    marginY: 2,
  }),
  callCenterDefinitionAvatar: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceContainerHighest,
  }),
  callCenterDefinitionTextContainer: {
    gap: '6px',
    flex: 1,
    flexDirection: 'column',
  },
  contactInfoContainer: {
    flexDirection: 'column',
    paddingY: 1,
  },
  contactInfoText: {
    fontWeight: '500',
  },
  nameFieldsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    spacing: 1,
  },
  backupPhoneContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    spacing: 1,
  },
  alertPreferencesContainer: {
    gap: 1,
    paddingY: 1,
  },
  alertPreferencesText: {
    fontWeight: '500',
  },
  saveButton: (theme: Theme) => ({
    minWidth: theme.spacing(12),
  }),
  divider: (theme: Theme) => ({
    color: theme.palette.divider,
    width: 'calc(100% + 48px)',
    marginLeft: '-24px',
    marginRight: '-24px',
  }),
}

export default useStyles
